import { useState } from "react";
import {
  CheckCircle2,
  XCircle,
  Ban,
  RotateCcw,
} from "lucide-react";

import API from "../../../services/api";

import "./ProviderCards.css";

function ProviderActionButtons({ provider }) {

  const [loading, setLoading] = useState(false);

  const status = provider.status?.toLowerCase();

  const updateStatus = async (url, body = null) => {

    try {

      setLoading(true);

      await API.put(url, body);

      window.location.reload();

    } catch (error) {

      console.error(error);

      alert(
        error.response?.data?.message ||
        "Something went wrong."
      );

    } finally {

      setLoading(false);

    }

  };

  const approve = () => {

    if (status === "approved") return;

    updateStatus(
      `/admin/providers/${provider._id}/approve`
    );

  };

  const reject = () => {

    const reason = window.prompt(
      "Enter rejection reason"
    );

    if (!reason) return;

    updateStatus(
      `/admin/providers/${provider._id}/reject`,
      { reason }
    );

  };

  const suspend = () => {

    if (!window.confirm(
      "Suspend this provider?"
    ))
      return;

    updateStatus(
      `/admin/providers/${provider._id}/suspend`
    );

  };

  const activate = () => {

    updateStatus(
      `/admin/providers/${provider._id}/activate`
    );

  };

  return (

    <div className="provider-card">

      <h3 className="card-title">

        Provider Actions

      </h3>

      <div className="provider-action-grid">

        <button
          className="action-btn approve"
          disabled={
            loading ||
            status === "approved"
          }
          onClick={approve}
        >

          <CheckCircle2 size={18} />

          {loading
            ? "Processing..."
            : "Approve"}

        </button>

        <button
          className="action-btn reject"
          disabled={loading}
          onClick={reject}
        >

          <XCircle size={18} />

          Reject

        </button>

        <button
          className="action-btn suspend"
          disabled={
            loading ||
            status === "suspended"
          }
          onClick={suspend}
        >

          <Ban size={18} />

          Suspend

        </button>

        <button
          className="action-btn activate"
          disabled={
            loading ||
            status === "approved"
          }
          onClick={activate}
        >

          <RotateCcw size={18} />

          Activate

        </button>

      </div>

    </div>

  );

}

export default ProviderActionButtons;